import React from "react";
import "./EnvAnalyticsHeader.css";

const EnvAnalyticsHeader = ({
  label,
  value,
  textColor,
  backgroundColor,
  onClick,
}) => (
  <div
    className={`EnvAnalyticsHeader__Card${onClick ? " EnvAnalyticsHeader__Card--clickable" : ""}`}
    style={{ backgroundColor }}
    role={onClick ? "button" : undefined}
    tabIndex={onClick ? 0 : undefined}
    aria-label={onClick ? `View ${label} swab list` : undefined}
    onClick={onClick}
    onKeyDown={onClick ? (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        onClick(event);
      }
    } : undefined}
  >
    <span
      className="EnvAnalyticsHeader__Label"
      style={{ color: textColor }}
    >
      {label}
    </span>
    <span className="EnvAnalyticsHeader__Value">
      {value}
    </span>
  </div>
);

export default EnvAnalyticsHeader;
